import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "../axios/axios";
import Context from "../../Context/Context";
import NotificacaoDeSucesso from "../Notificacao/NotificacaoDeSucesso";
import NotificacaoDeErro from "../Notificacao/NotificacaDeErro";
import { estadosCodigos } from "../Juridico/services/gerarEdital";

const campos = [
  "data_captacao",
  "data_ultima_vista",
  "processo",
  "estado",
  "nomenclatura_captada",
  "vara",
  "foro",
  "juizo",
  "situacao",
  // 'valor_acao_adv_conc', // comentado no seu model
  "valor_acao",
  "adv_constituido",
  "tipo_captacao",
  // 'advogado_escritorio', // comentado no seu model
  "advogado",
  "escritorio",
  "cidade",
  "bairro",
  "observacoes_captador",
  "relatorio",
  "responsavel",
  "status",
  "num_bens",
  "telefone",
  "email",
  "valor_avaliacao",
  "classificacao_imovel",
];

const camposSol = [
  "dataSolicitacao",
  "dataConclusao",
  "diretorio",
  "vara",
  "foro",
  "juizo",
  "dadosExequente",
  "advogado",
  "tipoBem",
  "estado",
  "prioridade",
  "processo",
  "status",
  "tipoSolicitacao",
  "solicitante_id",
  "departamento_id",
  "setor_id",
  "dadosDoImovel",
  "num_matricula",
  "cartorio",
  "link_relatorio"
];

function IndicacaoForm(props) {
  const { usuario } = useContext(Context);
  const [indicacao, setIndicacao] = useState({
    status: props.status,
  });
  const [solicitacao, setSolicitacao] = useState({});

  const [dataPrevista, setDataPrevista] = useState(false);
  const dataPrevistaRef = useRef(null);

  const [msn, setMsn] = useState();
  const [mostrarNotificacaoDeSucesso, setMostrarNotificacaoDeSucesso] =
    useState(false);
  const [mostrarNotificacaoDeErro, setMostrarNotificacaoDeErro] =
    useState(false);

  const [id, setId] = useState(props.id);
  const [indicacaoAntiga, setIndicacaoAntiga] = useState(props.captacaoAntiga);

  const [avaliado, setAvaliado] = useState(false)

  const [solicitar, setSolicitar] = useState(false)

  useEffect(() => {
    if (props.editing) {
      setIndicacao({
        ...indicacao,
        ...props.captacaoAntiga,
        adv_constituido: props?.captacaoAntiga?.adv_constituido ? "1" : "0",
        nomeclatura_captada: props.captacaoAntiga.termo_busca,
      });
      delete indicacao["termo_busca"];
    } else {
      setIndicacao({
        nomenclatura_captada: "",
        estado: "",
        relatorio: "",
        indicacao: "",
        tipo_captacao: "Mediata",
        data_captacao: new Date().toISOString(),
      });
    }
  }, []);

  const [mostrarNotificacao, setMostrarNotificacao] = useState(false);

  const verifyData = (data) => {
    const dataChecked = {};
    console.log(data.data_captacao);
    if (data.data_captacao && !data.data_captacao?.includes("T"))
      data.data_captacao = new Date(data.data_captacao + " ").toISOString();
    if (data.data_ultima_vista && !data.data_ultima_vista?.includes("T"))
      data.data_ultima_vista = new Date(
        data.data_ultima_vista + " ",
      ).toISOString();
    Object.keys(data).forEach((e) =>
      data[e]?.length >= 1 && campos.includes(e)
        ? (dataChecked[e] = data[e])
        : false,
    );
    return dataChecked;
  };

  const updateIndicacao = async (e) => {
    // e.preventDefault()
    // console.log('update', indicacao)
    // return
    e.preventDefault();
    delete indicacao["id"];
    delete indicacao["favoritos"];
    const checkedData = verifyData(indicacao);
    checkedData["num_bens"] = +indicacao.num_bens || 0;
    checkedData["responsavel_id"] = usuario.id;
    checkedData["adv_constituido"] = +checkedData?.adv_constituido;
    checkedData["valor_acao"] = checkedData?.valor_acao?.toString() || "";

    try {
      const route = props.new ? "/captacao/transform" : "/indicacao";
      const { data } = await axios.put(`${route}/${id}`, checkedData);
      if (props.new) {
        props.setIndicacao([...props.indicacao, data]);
      } else {
        props.setIndicacao((prevIndicacao) => {
          // const filtradas = prevIndicacao.filter((e) => e.id !== id);
          // return [...filtradas, data];
          const index = prevIndicacao.findIndex((e) => e.id == id);
          return [
            ...prevIndicacao.slice(0, index),
            data,
            ...prevIndicacao.slice(index + 1),
          ];
        });
      }
      setMostrarNotificacao(true);

      setMsn("Captação atualizada com sucesso!");
      setMostrarNotificacaoDeSucesso(true);
      props.setCaptacaoAntiga(null);
    } catch (error) {
      console.log(error);
      setMsn(
        `Erro ao atualizar a captação${error.response.data.message && ": " + error.response.data.message}`,
      );
      setMostrarNotificacaoDeErro(true);
    }
  };

  const createIndicacao = async (e) => {
    // console.log('create')
    // e.preventDefault()
    const checkedData = verifyData(indicacao);
    checkedData["responsavel_id"] = usuario.id;
    checkedData["num_bens"] = +indicacao.num_bens || 0;
    checkedData["adv_constituido"] = +checkedData?.adv_constituido;
    checkedData["valor_acao"] = checkedData?.valor_acao?.toString() || "";
    try {
      const { data } = await axios.post("/indicacao", checkedData);
      console.log(data, "indicação");
      props.setIndicacao([...props.indicacao, data]);
      setMsn("Indicação criada com sucesso!");
      setMostrarNotificacaoDeSucesso(true);
      resetForm();
      return data;
    } catch (error) {
      console.log(error);
      setMsn(
        `Erro ao atualizar a captação${error.response.data.message && ": " + error.response.data.message}`,
      );
      setMostrarNotificacaoDeErro(true);
    }
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setSolicitacao({
      ...solicitacao,
      [name]: value,
    });
  };

  const resetForm = () => {
    setIndicacao({
      data_captacao: new Date().toISOString(),
      data_ultima_vista: "",
      processo: "",
      estado: "",
      nomenclatura_captada: "",
      vara: "",
      foro: "",
      juizo: "",
      situacao: "",
      valor_acao: "",
      adv_constituido: 0,
      tipo_captacao: "Mediata",
      advogado: "",
      escritorio: "",
      cidade: "",
      bairro: "",
      observacoes_captador: "",
      relatorio: "",
      responsavel: "",
      status: "",
      num_bens: "",
      telefone: "",
      email: "",
      valor_avaliacao: "",
      classificacao_imovel: "",
    });
  };

  useEffect(() => {
    if (dataPrevista) {
      dataPrevistaRef.current.focus();
    }
  }, [dataPrevista]);

  const treatData = (data) => {
    if (data.includes("T")) return data;
    return new Date(data + " ").toISOString();
  };

  const createSolicitacao = async (dataSolicitacao) => {
    dataSolicitacao["solicitante_id"] = +usuario.id;
    if (!dataSolicitacao.status) dataSolicitacao.status = "Pendente";
    if (avaliado) dataSolicitacao.status = 'Concluído'


    dataSolicitacao["departamento_id"] = +dataSolicitacao["departamento_id"] || 7;
    dataSolicitacao["setor_id"] = +dataSolicitacao["setor_id"] || 11;

    if (dataSolicitacao["dataSolicitacao"])
      dataSolicitacao["dataSolicitacao"] = treatData(
        dataSolicitacao["dataSolicitacao"],
      );

    if (dataSolicitacao["dataConclusao"])
      dataSolicitacao["dataConclusao"] = treatData(
        dataSolicitacao["dataConclusao"].split("/").reverse().join("-"),
      );

    delete dataSolicitacao["celula_id"];

    const { data } = await axios.post(
      "/solicitacao/captacao/avaliacao",
      dataSolicitacao,
    );

    if (avaliado) {
      props.setIndicacao((prevIndicacao) => {
        // const filtradas = prevIndicacao.filter((e) => e.id !== id);
        // return [...filtradas, data];

        //id errado
        const index = prevIndicacao.findIndex((e) => e.id == data.id); // confeirir esse id
        return [
          ...prevIndicacao.slice(0, index),
          data,
          ...prevIndicacao.slice(index + 1),
        ];
      });
    }

    setSolicitacao({})
    setSolicitar(false)
    // pegar logica de salvar geral socket
  };

  const send = async (e) => {
    e.preventDefault();

    const converted = {};
    Object.keys(indicacao).map((e) => {
      if (camposSol.includes(e)) {
        converted[e] = indicacao[e];
      }
    });

    const dataSolicitacao = { ...solicitacao, ...converted };
    const { id } = await createIndicacao();

    if (solicitar) {
      if (dataSolicitacao.dadosDoImovel) dataSolicitacao.dadosDoImovel = JSON.stringify(dataSolicitacao.dadosDoImovel)
      dataSolicitacao["indicacao_id"] = id;
      await createSolicitacao(dataSolicitacao);
    }

  };

  const calcularDataConclusao = (prioridade, estado, dataBase) => {
    const diasPorPrioridade = {
      "São Paulo": { 1: 5, 2: 7, 3: 9, 4: 11 },
      Outros: { 1: 7, 2: 11 },
    };
    const dias = diasPorPrioridade[estado]?.[prioridade];
    if (!dias) return null;
    const dataInicial = dataBase ? new Date(dataBase) : new Date(); // Usa a dataBase ou o dia de hoje
    let diasUteis = 0;
    let dataConclusao = new Date(dataInicial);
    while (diasUteis < dias) {
      dataConclusao.setDate(dataConclusao.getDate() + 1);
      const diaSemana = dataConclusao.getDay();
      if (diaSemana !== 0 && diaSemana !== 6) {
        diasUteis++; // Ignorar domingos (0) e sábados (6)
      }
    }
    // Formatar a data no formato DD/MM/YYYY
    const dia = String(dataConclusao.getDate()).padStart(2, "0");
    const mes = String(dataConclusao.getMonth() + 1).padStart(2, "0");
    const ano = dataConclusao.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  useEffect(() => {
    if (
      solicitacao.estado &&
      solicitacao.prioridade &&
      solicitacao.dataSolicitacao
    ) {
      const dataConclusao = calcularDataConclusao(
        solicitacao.prioridade,
        solicitacao.estado,
        solicitacao.dataSolicitacao, // Passa a dataSolicitacao como base
      );
      setSolicitacao((prev) => ({ ...prev, dataConclusao }));
    }
  }, [solicitacao.estado, solicitacao.prioridade, solicitacao.dataSolicitacao]);

  return (
    <>
      <form className="!grid !grid-cols-2 gap-5" onSubmit={props.editing ? updateIndicacao : send}>
        <div className="relative w-full max-w-sm">
          <input
            type="date"
            id="data_captacao"
            className={`peer w-full !px-6 !pt-6 !pb-2 border rounded-xl text-gray-900 !bg-white placeholder-transparent
            focus:outline-none focus:ring-2 focus:ring-blue-500
          disabled:bg-gray-100 disabled:cursor-not-allowed`}
            disabled={true}
            value={indicacao?.data_captacao?.split("T")[0] || ""}
            onChange={(e) =>
              setIndicacao({
                ...indicacao,
                data_captacao: e.target.value,
              })
            }
          />
          <label
            htmlFor="data_captacao"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      ${indicacao?.data_captacao ? 'top-2 text-sm text-black' : ''}
      ${indicacao?.data_captacao && 'pointer-events-none'}
    `}
          >
            Data de Captação
          </label>
        </div>
        <div className="relative w-full max-w-sm">
          <input
            type="date"
            id="data_ultima_vista"
            className="peer w-full !px-6 !pt-6 !pb-2 border rounded-xl text-gray-900 bg-white placeholder-transparent focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={indicacao.data_ultima_vista?.split("T")[0] || ""}
            onChange={(e) =>
              setIndicacao({
                ...indicacao,
                data_ultima_vista: e.target.value,
              })
            }
            required
          />
          <label
            htmlFor="data_ultima_vista"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      ${indicacao.data_ultima_vista ? 'top-2 text-sm text-blue-500' : ''}
    `}
          >
            Data Última Vista
          </label>
        </div>
        <div className="relative w-full max-w-sm">

          <input
            type="text"
            id="Processo"
            placeholder=" "
            className="peer w-full px-6 pt-6 pb-2 border rounded-xl text-gray-900 bg-white placeholder-transparent focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={indicacao.processo || ""}
            onChange={(e) =>
              setIndicacao({ ...indicacao, ["processo"]: e.target.value })
            }
            onBlur={() => {
              const key = indicacao.processo.slice(15, 21)
              if (key.length == 6) {
                if (estadosCodigos[key]) {
                  setIndicacao({ ...indicacao, estado: estadosCodigos[key]?.nome })
                }
              }
            }}
            minLength={25}
            maxLength={25}
            required // perguntar se é requirido, se é obrigado
          />

          <label
            htmlFor="Processo"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
            peer-placeholder-shown:top-4
            peer-placeholder-shown:text-base
          peer-placeholder-shown:text-gray-400
            peer-focus:top-2
            peer-focus:text-sm
            peer-focus:text-blue-500
            ${indicacao.processo ? 'top-2 text-sm text-black' : ''}
          `}       >
            Processo
          </label>

        </div>


        <div className="relative w-full max-w-sm">
          <select
            id="estado"
            value={indicacao.estado || ""}
            onChange={(e) =>
              setIndicacao({ ...indicacao, estado: e.target.value })
            }
            required
            className="peer w-full appearance-none px-4 pt-6 pb-2 border border-gray-400 rounded-xl bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="" disabled hidden>Selecione um estado</option>
            <option value="Acre">Acre</option>
            <option value="Alagoas">Alagoas</option>
            <option value="Amapá">Amapá</option>
            <option value="Amazonas">Amazonas</option>
            <option value="Bahia">Bahia</option>
            <option value="Ceará">Ceará</option>
            <option value="Distrito Federal">Distrito Federal</option>
            <option value="Espírito Santo">Espírito Santo</option>
            <option value="Goiás">Goiás</option>
            <option value="Maranhão">Maranhão</option>
            <option value="Mato Grosso">Mato Grosso</option>
            <option value="Mato Grosso do Sul">Mato Grosso do Sul</option>
            <option value="Minas Gerais">Minas Gerais</option>
            <option value="Pará">Pará</option>
            <option value="Paraíba">Paraíba</option>
            <option value="Paraná">Paraná</option>
            <option value="Pernambuco">Pernambuco</option>
            <option value="Piauí">Piauí</option>
            <option value="Rio de Janeiro">Rio de Janeiro</option>
            <option value="Rio Grande do Norte">Rio Grande do Norte</option>
            <option value="Rio Grande do Sul">Rio Grande do Sul</option>
            <option value="Rondônia">Rondônia</option>
            <option value="Roraima">Roraima</option>
            <option value="Santa Catarina">Santa Catarina</option>
            <option value="São Paulo">São Paulo</option>
            <option value="Sergipe">Sergipe</option>
            <option value="Tocantins">Tocantins</option>
          </select>

          <label
            htmlFor="estado"
            className="absolute left-4 top-2 text-gray-500 transition-all duration-200 ease-in-out
            peer-focus:top-1 peer-focus:text-sm peer-focus:text-blue-500
            peer-valid:top-1 peer-valid:text-sm"
          >
            Estado
          </label>

          {/* Ícone da seta */}
          <svg
            className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-500"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.25 8.29a.75.75 0 01-.02-1.08z" />
          </svg>
        </div>

        <div className="relative w-full max-w-sm">
          <select
            id="nomenclatura_captada"
            value={indicacao.nomenclatura_captada || ""}
            onChange={(e) =>
              setIndicacao({
                ...indicacao,
                nomenclatura_captada: e.target.value,
              })
            }
            className="peer w-full appearance-none px-6 pt-6 pb-2 border rounded-xl text-gray-900 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="" disabled hidden>Selecione uma nomeclatura</option>
            <option value="Defiro a Penhora">Defiro a Penhora</option>
            <option value="Avaliação do Imóvel">Avaliação do Imóvel</option>
            <option value="Averbação da Penhora">Averbação da Penhora</option>
            <option value="Escritório Fidelizado">Escritório Fidelizado</option>
            <option value="Termo de Penhora">Termo de Penhora</option>
            <option value="Nomeação Espontânea">Nomeação Espontânea</option>
            <option value="Laudo de Avaliação">Laudo de Avaliação</option>
            <option value="Leilão negativo">Leilão negativo</option>
            <option value="Indique Leiloeiro">Indique Leiloeiro</option>
            <option value="Indique Gestor">Indique Gestor</option>
            <option value="Indicar Leiloeiro">Indicar Leiloeiro</option>
            <option value="Indicar Gestor">Indicar Gestor</option>
            <option value="Indicação de leiloeiro">Indicação de leiloeiro</option>
            <option value="Leilão Extrajudicial">Leilão Extrajudicial</option>
            <option value="Homologo">Homologo</option>
            <option value="Realização da penhora">Realização da penhora</option>
            <option value="Registro de Penhora">Registro de Penhora</option>
            <option value="Hasta Pública">Hasta Pública</option>
            <option value="Designação de Leilão">Designação de Leilão</option>
            <option value="Venda Direta - TRT">Venda Direta - TRT</option>
            <option value="Recuperação Judicial">Recuperação Judicial</option>
            <option value="Escritório Fidelizado +">Escritório Fidelizado +</option>
            <option value="Falência Judicial">Falência Judicial</option>
          </select>
          <svg
            className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-500"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.25 8.29a.75.75 0 01-.02-1.08z" />
          </svg>
          <label
            htmlFor="nomenclatura_captada"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${indicacao.nomenclatura_captada ? 'top-2 text-sm ' : 'top-1 text-base text-gray-400'}
    `}
          >
            Nomeclatura
          </label>
        </div>
        <div className="relative w-full max-w-sm">
          <input
            type="text"
            id="Vara"
            placeholder=""
            className="peer w-full px-6 pt-6 pb-2 border rounded-xl text-gray-900 bg-white placeholder-transparent focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={indicacao.vara || ""}
            onChange={(e) =>
              setIndicacao({ ...indicacao, ["vara"]: e.target.value })
            }
          />
          <label
            htmlFor="Vara"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
            peer-placeholder-shown:top-4
            peer-placeholder-shown:text-base
          peer-placeholder-shown:text-gray-400
            peer-focus:top-2
            peer-focus:text-sm
            peer-focus:text-blue-500
            ${indicacao.vara ? 'top-2 text-sm ' : ''}
          `}          >
            Vara
          </label>
        </div>


        <div className="relative w-full max-w-sm">
          <input
            type="text"
            id="foro"
            className={`peer w-full px-6 pt-6 pb-2 border rounded-xl text-gray-900 bg-white placeholder-transparent
      focus:outline-none focus:ring-2 focus:ring-blue-500`}
            placeholder="Foro"
            value={indicacao.foro || ""}
            onChange={(e) =>
              setIndicacao({ ...indicacao, foro: e.target.value })
            }
          />
          <label
            htmlFor="foro"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      ${indicacao.foro ? 'top-2 text-sm ' : ''}
    `}
          >
            Foro
          </label>
        </div>

        <div className="relative w-full max-w-sm">
          <input
            type="text"
            id="juizo"
            className="peer w-full px-6 pt-6 pb-2 border rounded-xl text-gray-900 bg-white placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Juiz"
            value={indicacao.juizo || ""}
            onChange={(e) =>
              setIndicacao({ ...indicacao, juizo: e.target.value })
            }
          />
          <label
            htmlFor="juizo"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                ${indicacao.juizo ? 'top-2 text-sm' : ''}`}
          >
            Juiz
          </label>
        </div>

        <div className="relative w-full max-w-sm">
          <select
            id="situacao"
            className="peer w-full appearance-none px-6 pt-6 pb-2 border rounded-xl text-gray-900 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={indicacao.situacao || ""}
            onChange={(e) =>
              setIndicacao({ ...indicacao, situacao: e.target.value })
            }
          >
            <option value="">Selecione a situação aqui</option>
            <option value="Nomeados">Nomeados</option>
            <option value="Pendente">Pendente</option>
            <option value="Acordo">Acordo</option>
            <option value="Adv indicou outra leiloaria">Adv indicou outra leiloaria</option>
            <option value="Juiz nomeou outra leiloaria">Juiz nomeou outra leiloaria</option>
            <option value="Iminente (indicados)">Iminente (indicados)</option>
            <option value="Processo extinto/arquivado">Processo extinto/arquivado</option>
            <option value="Penhora levantada">Penhora levantada</option>
            <option value="-">-</option>
            <option value="Prejudicado">Prejudicado</option>

          </select>
          <svg
            className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-500"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.25 8.29a.75.75 0 01-.02-1.08z" />
          </svg>

          <label
            htmlFor="situacao"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                ${indicacao.situacao ? 'top-2 text-sm' : ''}`}
          >
            Situação
          </label>
        </div>

        <div className="relative w-full max-w-sm">
          <input
            type="text"
            id="valor_acao"
            placeholder="Valor da Ação"
            className="peer w-full px-6 pt-6 pb-2 border rounded-xl text-gray-900 bg-white placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={indicacao.valor_acao || ""}
            onChange={(e) =>
              setIndicacao({ ...indicacao, valor_acao: e.target.value })
            }
          />
          <label
            htmlFor="valor_acao"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                ${indicacao.valor_acao ? 'top-2 text-sm' : ''}`}
          >
            Valor da Ação
          </label>
        </div>

        <div className="relative w-full max-w-sm">
          <select
            id="adv_constituido"
            className="peer w-full px-6 pt-6 pb-2 border rounded-xl bg-white text-gray-900 appearance-none
               focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={indicacao?.adv_constituido}
            onChange={(e) =>
              setIndicacao({ ...indicacao, adv_constituido: e.target.value })
            }
          >
            <option value="0">Não</option>
            <option value="1">Sim</option>
          </select>

          <svg
            className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-500"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.25 8.29a.75.75 0 01-.02-1.08z" />
          </svg>


          <label
            htmlFor="adv_constituido"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                ${indicacao?.adv_constituido !== "" ? 'top-2 text-sm' : ''}`}
          >
            Advogado Constituído
          </label>
        </div>

        <div className="relative w-full max-w-sm">
          <select
            id="tipo_captacao"
            className="peer w-full px-6 pt-6 pb-2 border rounded-xl bg-white text-gray-900 appearance-none
               focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={indicacao.tipo_captacao || "Mediata"}
            onChange={(e) =>
              setIndicacao({ ...indicacao, tipo_captacao: e.target.value })
            }
          >
            <option value="Mediata">Mediata</option>
            <option value="Imediata">Imediata</option>
            <option value="Espontânea">Espontânea</option>
          </select>
          <svg
            className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-500"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.25 8.29a.75.75 0 01-.02-1.08z" />
          </svg>
          <label
            htmlFor="tipo_captacao"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                ${indicacao.tipo_captacao !== "" ? 'top-2 text-sm' : ''}`}
          >
            Tipo de Captação
          </label>
        </div>

        <div className="relative w-full max-w-sm">
          <input
            type="text"
            id="advogado"
            placeholder=" "
            className="peer w-full px-6 pt-6 pb-2 border rounded-xl text-gray-900 bg-white placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={indicacao.advogado || ""}
            onChange={(e) =>
              setIndicacao({ ...indicacao, advogado: e.target.value })
            }
          />
          <label
            htmlFor="advogado"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                ${indicacao.advogado ? 'top-2 text-sm' : ''}`}
          >
            Advogado
          </label>
        </div>

        <div className="relative w-full max-w-sm">
          <input
            type="text"
            id="Escritorio"
            placeholder=" "
            className="peer w-full px-6 pt-6 pb-2 border rounded-xl text-gray-900 bg-white placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={indicacao.escritorio || ""}

            onChange={(e) =>
              setIndicacao({ ...indicacao, ["escritorio"]: e.target.value })
            }
          />
          <label
            htmlFor="Escritorio"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                ${indicacao.escritorio ? 'top-2 text-sm' : ''}`}
          >
            Escrítorio
          </label>
        </div>

        <div className="relative w-full max-w-sm">

          <input
            type="text"
            id="email"
            placeholder=" "
            className="peer w-full px-6 pt-6 pb-2 border rounded-xl text-gray-900 bg-white placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={indicacao.email}
            onChange={(e) =>
              setIndicacao({ ...indicacao, ["email"]: e.target.value })
            }
          />
          <label
            htmlFor="email"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                ${indicacao.email ? 'top-2 text-sm' : ''}`}
          >
            Email
          </label>

        </div>

        <div className="relative w-full max-w-sm">

          <input
            type="text"
            id="telefone"
            placeholder=" "
            className="peer w-full px-6 pt-6 pb-2 border rounded-xl text-gray-900 bg-white placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={indicacao.telefone}
            onChange={(e) =>
              setIndicacao({ ...indicacao, ["telefone"]: e.target.value })
            }
          />
          <label
            htmlFor="telefone"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                ${indicacao.telefone ? 'top-2 text-sm' : ''}`}
          >
            Telefone
          </label>
        </div>

        <div className="relative w-full max-w-sm">

          <input
            type="text"
            id="valor_avaliacao"
            placeholder=" "
            className="peer w-full px-6 pt-6 pb-2 border rounded-xl text-gray-900 bg-white placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={indicacao.valor_avaliacao || ""}
            onChange={(e) =>
              setIndicacao({
                ...indicacao,
                ["valor_avaliacao"]: e.target.value,
              })
            }
          />
          <label
            htmlFor="valor_avaliacao"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                ${indicacao.valor_avaliacao ? 'top-2 text-sm' : ''}`}
          >
            Valor da Avaliação
          </label>
        </div>

        <div className="relative w-full max-w-sm">

          <input
            type="text"
            id="classificacao_imovel"
            placeholder=" "
            className="peer w-full px-6 pt-6 pb-2 border rounded-xl text-gray-900 bg-white placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={indicacao.classificacao_imovel}
            onChange={(e) =>
              setIndicacao({
                ...indicacao,
                ["classificacao_imovel"]: e.target.value,
              })
            }
          />
          <label
            htmlFor="classificacao_imovel"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                ${indicacao.classificacao_imovel ? 'top-2 text-sm' : ''}`}
          >
            Classificação do Imóvel
          </label>
        </div>


        <div className="relative w-full max-w-sm">

          <input
            type="text"
            id="Cidade"
            placeholder=" "
            className="peer w-full px-6 pt-6 pb-2 border rounded-xl text-gray-900 bg-white placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={indicacao.cidade || ""}
            onChange={(e) =>
              setIndicacao({ ...indicacao, ["cidade"]: e.target.value })
            }
          />
          <label
            htmlFor="cidade"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                ${indicacao.cidade ? 'top-2 text-sm' : ''}`}
          >
            Cidade
          </label>
        </div>


        <div className="relative w-full max-w-sm">

          <input
            type="text"
            id="bairro"
            placeholder=" "
            className="peer w-full px-6 pt-6 pb-2 border rounded-xl text-gray-900 bg-white placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={indicacao.bairro || ""}
            onChange={(e) =>
              setIndicacao({ ...indicacao, ["bairro"]: e.target.value })
            }
          />
          <label
            htmlFor="bairro"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                ${indicacao.bairro ? 'top-2 text-sm' : ''}`}
          >
            Bairro
          </label>
        </div>

        <div className="relative w-full max-w-sm">

          <input
            type="text"
            id="observacoes_captador"
            placeholder=" "
            className="peer w-full px-6 pt-6 pb-2 border rounded-xl text-gray-900 bg-white placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={indicacao.observacoes_captador || ""}
            onChange={(e) =>
              setIndicacao({
                ...indicacao,
                ["observacoes_captador"]: e.target.value,
              })
            }
          />
          <label
            htmlFor="observacoes_captador"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                ${indicacao.observacoes_captador ? 'top-2 text-sm' : ''}`}
          >
            Observação do Captador
          </label>
        </div>

        <div className="relative w-full max-w-sm">

          <select
            className="peer w-full px-6 pt-6 pb-2 border rounded-xl bg-white text-gray-900 appearance-none
               focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={indicacao.relatorio || ""} // trocar termo de busca se necessario
            onChange={(e) =>
              setIndicacao({ ...indicacao, ["relatorio"]: e.target.value })
            }
          >
            <option value="">Selecione Aqui</option>
            <option value="Rejeitado">Rejeitado</option>
            <option value="Homologado">Homologado</option>
            <option value="Pendente">Pendente</option>
            <option value="Juntado">Juntado</option>
            <option value="Não se enquadra">Não se enquadra</option>
          </select>
          <svg
            className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-500"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.25 8.29a.75.75 0 01-.02-1.08z" />
          </svg>
          <label
            htmlFor="tipo_captacao"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                ${indicacao.relatorio !== "" ? 'top-2 text-sm' : ''}`}
          >
            Relatorio
          </label>
        </div>

        <div className="relative w-full max-w-sm">

          <input
            type="text"
            id="responsavel"
            placeholder=" "
            className="peer w-full px-6 pt-6 pb-2 border rounded-xl text-gray-900 bg-white placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={indicacao.responsavel || ""}
            onChange={(e) =>
              setIndicacao({ ...indicacao, ["responsavel"]: e.target.value })
            }
          />
          <label
            htmlFor="responsavel"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                ${indicacao.responsavel ? 'top-2 text-sm' : ''}`}
          >
            Responsavel
          </label>
        </div>

        <div className="relative w-full max-w-sm">

          <input
            type="text"
            id="num_bens"
            placeholder=" "
            className="peer w-full px-6 pt-6 pb-2 border rounded-xl text-gray-900 bg-white placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"              value={indicacao?.num_bens?.toString() || ""}
            onChange={(e) =>
              setIndicacao({ ...indicacao, ["num_bens"]: e.target.value })
            }
          />
          <label
            htmlFor="num_bens"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                ${indicacao.num_bens ? 'top-2 text-sm' : ''}`}
          >
            Número de Bens
          </label>
        </div>

        <div className="relative">
          <select
            id="solicitar"
            className="peer w-full appearance-none rounded-xl border bg-white px-6 pt-6 pb-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onChange={(e) => setSolicitar(e.target.value === 'Sim')}
            defaultValue=""
          >
            <option value="" disabled>Selecione</option>
            <option value="Não">Não</option>
            <option value="Sim">Sim</option>
          </select>

          <label
            htmlFor="solicitar"
            className="pointer-events-none absolute left-6 top-2 text-sm text-gray-500 transition-all
               duration-200 peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
               peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400"
          >
            Deseja Solicitar?
          </label>

          <svg
            className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>


        {(!props.editing && solicitar) && (
          <>
            <label className="flex justify-start items-center !border-none">
              <p className="whitespace-nowrap !border-none !border-transparent">
                Já foi avaliado
              </p>
              <input type="checkbox" value={avaliado} onChange={(e) => setAvaliado(e.target.checked)} className="m-0 !shadow-none" />
            </label>

            {!avaliado && (
              <>
                <div className="relative w-full max-w-sm">
                  <select
                    id="departamento_id"
                    name="departamento_id"
                    className="peer w-full appearance-none rounded-xl border bg-white px-6 pt-6 pb-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={solicitacao.departamento_id}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Selecione o departamento</option>
                    <option value="4">Comercial</option>
                    <option value="2">Jurídico</option>
                    <option value="3">Estratégico</option>
                    <option value="5">Marketing</option>
                    <option value="1">Administrativo</option>
                    <option value="6">Recuperação Extrajudicial</option>
                    <option value="7">Nenhum</option>
                  </select>

                  <label
                    htmlFor="departamento_id"
                    className={`pointer-events-none absolute left-6 top-2 text-sm text-gray-500 transition-all
                duration-200 peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                ${solicitacao.departamento_id ? 'top-2 text-sm' : 'top-2 text-base text-gray-400'}`}
                  >
                    Encaminhar
                  </label>

                  <svg
                    className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </div>

                <div className="relative w-full max-w-sm">
                  <select
                    id="setor_id"
                    name="setor_id"
                    className="peer w-full appearance-none rounded-xl border bg-white px-6 pt-6 pb-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={solicitacao.setor_id}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Selecione o setor</option>
                    <option value="2">Negócios</option>
                    <option value="1">Captação</option>
                    <option value="3">API</option>
                    <option value="4">Controladoria</option>
                    <option value="5">Editais</option>
                    <option value="6">Encerramentos</option>
                    <option value="7">Publicação</option>
                    <option value="8">Financeiro</option>
                    <option value="9">Departamento Pessoal</option>
                    <option value="10">Infraestrutura</option>
                    <option value="11">Nenhum</option>
                  </select>

                  <label
                    htmlFor="setor_id"
                    className={`pointer-events-none absolute left-6 top-2 text-sm text-gray-500 transition-all
                duration-200 peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                ${solicitacao.setor_id ? 'top-2 text-sm' : 'top-2 text-base text-gray-400'}`}
                  >
                    Setor
                  </label>

                  <svg
                    className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </div>

                <div className="relative w-full  col-span-2">
                  <select
                    id="celula_id"
                    name="celula_id"
                    className="peer w-full appearance-none rounded-xl border bg-white px-6 pt-6 pb-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={solicitacao.celula_id}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>Selecione a célula</option>
                    <option value="3">Avaliação</option>
                    <option value="1">Tecnologia</option>
                    <option value="2">Prospecção</option>
                    <option value="4">Cadastro</option>
                    <option value="5">Atendimento</option>
                    <option value="6">Mediata</option>
                    <option value="7">Imediata</option>
                    <option value="8">Nenhuma</option>
                  </select>

                  <label
                    htmlFor="celula_id"
                    className={`pointer-events-none absolute left-6 top-2 text-sm text-gray-500 transition-all
                duration-200 peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                ${solicitacao.celula_id ? 'top-2 text-sm' : 'top-4 text-base text-gray-400'}`}
                  >
                    Célula
                  </label>

                  <svg
                    className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </div>

                {/* Condicional para mostrar os campos se a opção for "Avaliacao" */}
                {solicitacao.celula_id == 3 && (
                  <>
                    <div
                      className={`checkbox-container flex items-center justify-start`}
                    >
                      <label
                        className={`text-black flex gap-5 whitespace-nowrap border bg-white border-gray-300 px-6 pt-6 pb-2 rounded-lg text-gray-500 hover:bg-gray-700  hover:text-semibold hover:border-none hover:cursor-pointer hover:text-white ${dataPrevista && "bg-black rounded-md !text-black"} w-[100%] m-auto text-center justify-center`}
                      >
                        Data Prevista
                        <input
                          className="hidden"
                          type="checkbox"
                          name="dataPrevista"
                          onChange={() => setDataPrevista(!dataPrevista)}
                        />
                      </label>
                    </div>

                    {dataPrevista ? (
                      <div className="relative w-full max-w-sm">
                        <input
                          type="date"
                          id="dataConclusao"
                          ref={dataPrevistaRef}
                          name="dataConclusao"
                          className={`peer w-full !px-6 !pt-6 !pb-2 border rounded-xl text-gray-900 bg-white
                          placeholder-transparent focus:outline-none focus:ring-2 focus:ring-blue-500`}
                          value={solicitacao.dataConclusao}
                          onChange={handleChange}
                          required
                        />
                        <label
                          htmlFor="dataConclusao"
                          className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                            peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                            peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                            ${solicitacao.dataConclusao ? 'top-2 text-sm ' : ''}
                            ${solicitacao.dataConclusao && 'pointer-events-none'}
                          `}
                        >
                          Data Prevista
                        </label>
                      </div>
                    ) : (
                      <div className="relative w-full max-w-sm">
                        <input
                          type="date"
                          id="dataSolicitacao"
                          name="dataSolicitacao"
                          className={`peer w-full !px-6 !pt-6 !pb-2 border rounded-xl text-gray-900 bg-white
                          placeholder-transparent focus:outline-none focus:ring-2 focus:ring-blue-500`}
                          value={solicitacao.dataSolicitacao}
                          onChange={handleChange}
                          required
                        />
                        <label
                          htmlFor="dataSolicitacao"
                          className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                          peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                          peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                          ${solicitacao.dataSolicitacao ? 'top-2 text-sm ' : ''}
                          ${solicitacao.dataSolicitacao && 'pointer-events-none'}
                          `}
                        >
                          Data de Solicitação
                        </label>
                      </div>
                    )}

                    <div className="relative w-full max-w-sm">
                      <input
                        type="text"
                        id="dadosExequente"
                        name="dadosExequente"
                        className={`peer w-full px-6 pt-6 pb-2 border rounded-xl text-gray-900 bg-white
      placeholder-transparent focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        value={solicitacao.dadosExequente}
                        onChange={handleChange}
                        placeholder="Dados do Exequente"
                        required
                      />
                      <label
                        htmlFor="dadosExequente"
                        className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
                        peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                        peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                        ${solicitacao.dadosExequente ? 'top-2 text-sm' : ''}
                        ${solicitacao.dadosExequente && 'pointer-events-none'}
                      `}
                      >
                        Dados do Exequente
                      </label>
                    </div>

                    <div className="relative w-full max-w-sm">
                      <select
                        id="tipoBem"
                        name="tipoBem"
                        className="peer w-full appearance-none rounded-xl border bg-white px-6 pt-6 pb-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={solicitacao.tipoBem}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>Selecione o tipo do bem</option>
                        <option value="movel">Móvel</option>
                        <option value="imovel">Imóvel</option>
                        <option value="semovente">Semovente</option>
                      </select>

                      <label
                        htmlFor="tipoBem"
                        className={`pointer-events-none absolute left-6 top-2 text-sm text-gray-500 transition-all duration-200
                        peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                        peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                        ${solicitacao.tipoBem ? 'top-2 text-sm ' : ''}`}
                      >
                        Tipo do Bem
                      </label>

                      <svg
                        className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                      </svg>
                    </div>

                    <div className="relative w-full max-w-sm">
                      <select
                        id="estado"
                        name="estado"
                        className="peer w-full appearance-none rounded-xl border bg-white px-6 pt-6 pb-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={solicitacao.estado}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>Selecione o Estado</option>
                        <option value="São Paulo">São Paulo</option>
                        <option value="Outros">Outros</option>
                      </select>

                      <label
                        htmlFor="estado"
                        className={`pointer-events-none absolute left-6 top-2 text-sm text-gray-500 transition-all duration-200
                        peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                        peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                        ${solicitacao.estado ? 'top-2 text-sm ' : ''}`}
                      >
                        Estado
                      </label>

                      <svg
                        className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                      </svg>
                    </div>


                    <div className="relative w-full max-w-sm">
                      <select
                        id="prioridade"
                        name="prioridade"
                        value={solicitacao.prioridade}
                        onChange={handleChange}
                        className="peer w-full appearance-none rounded-xl border bg-white px-6 pt-6 pb-2 text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
                        required
                      >
                        <option value="" disabled>Selecione a Prioridade</option>
                        {solicitacao.estado === "São Paulo" ? (
                          <>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                          </>
                        ) : (
                          <>
                            <option value="1">1</option>
                            <option value="2">2</option>
                          </>
                        )}
                      </select>

                      <label
                        htmlFor="prioridade"
                        className={`pointer-events-none absolute left-6 top-2 text-sm text-gray-500 transition-all duration-200
                        peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                        peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                        ${solicitacao.prioridade ? 'top-2 text-sm ' : ''}
    `}
                      >
                        Prioridade
                      </label>

                      <svg
                        className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                      </svg>
                    </div>


                    <div className="relative w-full max-w-sm">
                      <input
                        type="text"
                        id="dataConclusao"
                        name="dataConclusao"
                        value={
                          solicitacao?.dataConclusao
                            ? solicitacao.dataConclusao.split("-").reverse().join("/")
                            : ""
                        }
                        onChange={handleChange}
                        placeholder="Data de conclusão"
                        className="peer w-full rounded-xl border bg-white px-6 pt-6 pb-2 text-gray-900 placeholder-transparent
                        disabled:bg-gray-100 disabled:cursor-not-allowed
                        focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                      <label
                        htmlFor="dataConclusao"
                        className={`absolute left-6 top-2 text-sm text-gray-500 transition-all duration-200
                        peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                        peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                        ${solicitacao?.dataConclusao ? 'top-2 text-sm ' : ''}
    `}
                      >
                        Data de Conclusão
                      </label>
                    </div>


                    <div className="relative w-full max-w-sm">
                      <select
                        id="status"
                        name="status"
                        value={solicitacao.status}
                        onChange={handleChange}
                        className="peer w-full rounded-xl border bg-white px-6 pt-6 pb-2 text-gray-900
                        focus:outline-none focus:ring-2 focus:ring-blue-500
                        disabled:bg-gray-100 disabled:cursor-not-allowed appearance-none"
                      >
                        <option value="Pendente">Pendente</option>
                        {usuario.role.includes("Captação") && (
                          <>
                            <option value="Enviado">Enviado</option>
                            <option value="Rejeitado">Rejeitado</option>
                            <option value="Concluído">Concluído</option>
                          </>
                        )}
                        {usuario.role.includes("Avaliação") && (
                          <>
                            <option value="Concluído">Concluído</option>
                            <option value="Prejudicado">Prejudicado</option>
                            <option value="Correção">Correção</option>
                            <option value="Realizado">Realizado</option>
                          </>
                        )}
                      </select>
                      <svg
                        className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                      </svg>
                      <label
                        htmlFor="status"
                        className={`absolute left-6 top-2 text-sm text-gray-500 transition-all duration-200
                        peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                        peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                        ${solicitacao?.status ? 'top-2 text-sm ' : ''}
    `}
                      >
                        Status
                      </label>
                    </div>


                    <div className="relative w-full max-w-sm">
                      <select
                        id="tipoSolicitacao"
                        name="tipoSolicitacao"
                        required
                        value={solicitacao.tipoSolicitacao}
                        onChange={handleChange}
                        className="peer w-full rounded-xl border bg-white px-6 pt-6 pb-2 text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed appearance-none"
                      >
                        <option value="">Selecione o tipo da solicitação</option>
                        <option value="Relatórios Comparativos + Pareceres">
                          Relatórios Comparativos + Pareceres
                        </option>
                        <option value="Pareceres técnicos">Pareceres técnicos</option>
                        <option value="Análise de Matrícula">Análise de Matrícula</option>
                        <option value="Análise de Precificação">Análise de Precificação</option>
                        <option value="Busca de Bens">Busca de Bens</option>
                        <option value="Emissão de documentos">Emissão de documentos</option>
                        <option value="Avaliação Extrajudiciais">Avaliação Extrajudiciais</option>
                        <option value="Sem tipo">Sem tipo</option>
                      </select>
                      <svg
                        className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                      </svg>
                      <label
                        htmlFor="tipoSolicitacao"
                        className={`absolute left-6 top-2 text-sm text-gray-500 transition-all duration-200
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      ${solicitacao?.tipoSolicitacao ? 'top-2 text-sm ' : ''}
    `}
                      >
                        Tipo da solicitação
                      </label>
                    </div>


                    <div className="relative w-full">
                      <input
                        id="diretorio"
                        name="diretorio"
                        type="text"
                        value={solicitacao.diretorio}
                        onChange={handleChange}
                        placeholder=" " // necessário para label flutuante
                        className="peer w-full rounded-xl border border-gray-300 bg-white px-4 pt-6 pb-2 text-sm text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
                      />
                      <label
                        htmlFor="diretorio"
                        className={`absolute left-4 text-sm text-gray-500 bg-white px-1 transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${solicitacao?.diretorio ? 'top-2 text-sm text-blue-500' : 'top-4'}
    `}
                      >
                        Diretório
                      </label>
                    </div>



                    <div className="relative w-full">
                      <textarea
                        name="dadosDoImovel"
                        id="dadosDoImovel"
                        placeholder=" "
                        onChange={handleChange}
                        value={solicitacao.dadosDoImovel}
                        className="peer w-full border border-gray-300 rounded-md p-4 pt-6 text-sm bg-white focus:outline-none focus:border-blue-500"


                        rows={4}
                      />
                      <label
                        htmlFor="dadosDoImovel"
                        className={`
      absolute left-4 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${solicitacao?.dadosDoImovel ? 'top-2 text-sm ' : 'top-4'}
    `}
                      >
                        Dados do Imóvel
                      </label>
                    </div>



                    <div className="relative w-full">
                      <textarea
                        name="num_matricula"
                        id="num_matricula"
                        placeholder=" "
                        onChange={handleChange}
                        value={solicitacao.num_matricula}
                        className="peer w-full border border-gray-300 rounded-md p-8 pt-7 text-sm bg-white focus:outline-none focus:border-blue-500"
                        rows={3}
                      />
                      <label
                        htmlFor="num_matricula"
                        className={`
      absolute left-4 text-sm text-gray-500 transition-all duration-200 bg-white px-1
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${solicitacao?.num_matricula ? 'top-2 text-sm ' : 'top-4'}
    `}
                      >
                        Número da Matrícula
                      </label>
                    </div>


                    <div className="relative w-full">
                      <textarea
                        name="cartorio"
                        id="cartorio"
                        placeholder=" "
                        onChange={handleChange}
                        value={solicitacao.cartorio}
                        className="peer w-full border border-gray-300 rounded-md p-4 pt-6 text-sm bg-white focus:outline-none focus:border-blue-500"
                        rows={3}
                      />
                      <label
                        htmlFor="cartorio"
                        className={`
      absolute left-4 text-sm text-gray-500 transition-all duration-200 bg-white px-1
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${solicitacao?.cartorio ? 'top-2 text-sm ' : 'top-4'}
    `}
                      >
                        Cartório
                      </label>
                    </div>


                    {solicitacao.status === "Rejeitado" && (
                      <div className="relative w-full col-span-2">
                        <textarea
                          name="motivo_rejeicao"
                          id="motivo_rejeicao"
                          placeholder=" "
                          onChange={handleChange}
                          value={solicitacao.motivo_rejeicao}
                          className="peer w-full border border-gray-300 rounded-md p-4 pt-6 text-sm bg-white focus:outline-none focus:border-blue-500"
                          rows={4}
                        />
                        <label
                          htmlFor="motivo_rejeicao"
                          className={`
        absolute left-4 text-sm text-gray-500 transition-all duration-200 bg-white px-1
        peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
        peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
        ${solicitacao?.motivo_rejeicao ? 'top-2 text-sm ' : 'top-4'}
      `}
                        >
                          Descreva o motivo da rejeição
                        </label>
                      </div>
                    )}

                  </>

                )}
              </>
            )}
          </>
        )}

        <button className="bg-black text-white py-3 w-[100%] m-auto min-w-[400px] col-span-full">
          Salvar Indicação
        </button>

      </form>

      <NotificacaoDeSucesso
        mostrar={mostrarNotificacaoDeSucesso}
        onClose={() => setMostrarNotificacaoDeSucesso(false)}
        mensagem={msn}
      />
      <NotificacaoDeErro
        mostrar={mostrarNotificacaoDeErro}
        onClose={() => setMostrarNotificacaoDeErro(false)}
        mensagem={msn}
      />
    </>
  );
}

export default IndicacaoForm;
